import React, { useEffect, useState } from "react";
import { AccessTimeOutlined, CheckCircleOutline, InfoOutlined, LoginOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import styles from "./RegistrationPage.module.css";

const REDIRECT_SECONDS = 15;

const CadastroConcluido: React.FC = () => {
  const navigate = useNavigate();
  const [secondsRemaining, setSecondsRemaining] = useState(REDIRECT_SECONDS);

  const goToLogin = () => navigate("/login", { replace: true });

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setSecondsRemaining((current) => {
        if (current <= 1) {
          window.clearInterval(intervalId);
          goToLogin();
          return 0;
        }

        return current - 1;
      });
    }, 1000);

    return () => window.clearInterval(intervalId);
  }, []);

  return (
    <section className={styles.successScreen} aria-live="polite">
      <div className={styles.successSeal} aria-hidden="true">
        <CheckCircleOutline />
      </div>

      <h1 className={styles.successTitle}>Cadastro concluído com sucesso!</h1>
      <p className={styles.successDescription}>
        Seus dados foram registrados no SISCAP.<br />
        Agora você já pode acessar o sistema utilizando o CPF ou e-mail e a senha cadastrada.
      </p>

      <div className={styles.successInfoBox}>
        <InfoOutlined aria-hidden="true" />
        <p>
          Guarde seus dados de acesso.<br />
          Caso esqueça a senha, utilize a opção <strong>“Esqueci minha senha”</strong> na tela de login.
        </p>
      </div>

      <div className={styles.redirectHeading} aria-hidden="true">
        <span />
        <strong>Redirecionando</strong>
        <span />
      </div>

      <p className={styles.redirectDescription}>
        <AccessTimeOutlined aria-hidden="true" />
        Você será direcionado para a tela de login em <strong>{secondsRemaining} segundos.</strong>
      </p>

      <Button
        className={styles.loginRedirectButton}
        variant="contained"
        startIcon={<LoginOutlined />}
        onClick={goToLogin}
      >
        Ir para a tela de login
      </Button>
    </section>
  );
};

export default CadastroConcluido;
